var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.669556 13.4723C0.670991 19.7298 5.08336 25.0577 11.0762 26.0384V17.1484H7.94695V13.4723H11.0799V10.6739C10.9399 9.34789 11.3791 8.02635 12.2784 7.06769C13.1777 6.10903 14.444 5.61262 15.7338 5.71309C16.6595 5.72851 17.583 5.81354 18.4967 5.96749V9.09535H16.9376C16.4009 9.02285 15.8613 9.20566 15.4708 9.59228C15.0803 9.97889 14.8812 10.5275 14.9296 11.0835V13.4723H18.3475L17.801 17.1497H14.9296V26.0384C21.4107 24.9821 25.9555 18.878 25.2715 12.1482C24.5874 5.41846 18.914 0.418926 12.3613 0.771588C5.80858 1.12425 0.670597 6.70565 0.669556 13.4723Z",
    fill: "#3E4756"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialFacebook);
export default __webpack_public_path__ + "static/media/IconSocialFacebook.172833de.svg";
export { ForwardRef as ReactComponent };